<template>
	<div v-if="pageShow">
		<van-pull-refresh v-model="refreshing" @refresh="onRefresh" :disabled="!showList" :style="{ 'min-height': '100vh' }">
			<van-list v-model="loading" :finished="finished" finished-text="" @load="onLoad">
				<div>
					<van-sticky>
						<div class="search-box">
							<div class="row search-view">
								<div class="row cc main">
									<van-image class="search-img" :src="require('@/assets/search.png')" fit="cover" />
									<input type="text" placeholder="请输入要搜索的关键词" v-model="keywords" @keyup.enter="search" />
								</div>
								<div class="row cc cancel" @click="navBack()">取消</div>
							</div>
						</div>
					</van-sticky>
					<div class="container" v-show="!showList">
						<div v-show="logList.length > 0">
							<div class="row cb title-view">
								<div class="row "><div class="title">历史搜索</div></div>
								<van-image class="del" :src="require('@/assets/search/del.png')" fit="cover" @click="deleteLog()" />
							</div>
							<div class="row history">
								<div class="row cc h-item" v-for="(item, index) in logList" :key="index" @click="tapKeywords(item.search_text)">
									<span>{{ item.search_text }}</span>
								</div>
							</div>
						</div>
						<div class="row cb title-view"><div class="title">热门问题</div></div>
						<div class="col hot-list">
							<div class="row hot-item" v-for="(item, index) in hotQuestionList" :key="index" @click="navDetail(item.id)">
								<div class="row cc num">{{ index + 1 }}</div>
								<div class="title text-ellipsis">{{ item.title }}</div>
								<div class="row cc eye">
									<van-image class="img" :src="require('@/assets/search/eye.png')" fit="cover" />
									<span>{{ item.view_num }}</span>
								</div>
							</div>
						</div>
					</div>
					<div v-show="showList && !refreshing && !searching">
						<div class="container">
							<div class="row cb title-view">
								<div class="row ">
									<div class="title">搜索结果</div>
									<div class="title">：</div>
									<div class="result">{{ keywords_confirm }}</div>
								</div>
							</div>
							<div v-show="list.length == 0">
								<div class="col cc empty-view">
									<van-image class="img" :src="require('@/assets/search-none.png')" fit="cover" />
									<span>抱歉！您搜索的内容当前暂无相关问题！</span>
								</div>
								<div class="row cc">
									<div class="row cc btn-ask" @click="navAsk()">
										<van-image class="img" :src="require('@/assets/edit.png')" fit="cover" />
										<span>去提问</span>
									</div>
								</div>
							</div>
						</div>
						<div class="search-reslut" v-show="list.length != 0">
							<div class="search-list">
								<template v-for="(item, index) in list">
									<reward :item="item"></reward>
								</template>
							</div>
							<template>
								<div class="col cc empty-view"><span>没有找到想了解的问题？</span></div>
								<div class="row cc">
									<div class="row cc btn-ask" @click="navAsk()">
										<van-image class="img" :src="require('@/assets/edit.png')" fit="cover" />
										<span>去提问</span>
									</div>
								</div>
							</template>
						</div>
					</div>
				</div>
			</van-list>
		</van-pull-refresh>
	</div>
</template>

<script>
import { Toast } from 'vant';
import { mapState } from 'vuex';
import reward from '@/components/list/reward.vue';
export default {
	data() {
		return {
			pageShow: false,
			keywords: '',
			keywords_confirm: '',
			logList: [],
			hotQuestionList: [],
			showList: false,
			page: 0,
			pageSize: 20,
			list: [],
			loading: false,
			finished: false,
			refreshing: false,
			searching: false
		};
	},
	computed: {
		...mapState(['majorInfo'])
	},
	components: {
		reward
	},
	async created() {
		if (this.$route.query.keywords) {
			this.showList = true;
			this.keywords = this.keywords_confirm = this.$route.query.keywords;
		}
		if (!this.pageShow) {
			this.$toast.loading({
				duration: 0,
				message: '加载中...',
				forbidClick: true
			});
		}
		await this.getLogList();
		await this.getHotQList();
		this.pageShow = true;
		this.$toast.clear();
	},
	methods: {
		navDetail(id) {
			this.$router.push({
				path: '/ask/detail',
				query: { id }
			});
		},
		async getLogList() {
			let logList = await this.$service.post('home/searchList', {});
			this.logList = logList.data;
		},
		async getHotQList() {
			let hotQuestionList = await this.$service.post('question/hotQuestion', { page: 1, pageSize: 6 });
			this.hotQuestionList = hotQuestionList.data.data;
		},
		navBack() {
			this.$router.go(-1);
		},
		tapKeywords(keywords) {
			this.keywords = keywords;
			this.search();
		},
		async search() {
			this.keywords_confirm = this.keywords;
			console.log('onRefresh');
			this.page = 0;
			this.finished = false;
			this.list = [];
			this.searching = true;
			await this.onLoad();
			this.getLogList();
		},
		navAsk() {
			this.$router.push({
				path: '/ask/add'
			});
		},
		async onLoad() {
			if (this.keywords == '') {
				this.list = [];
				this.showList = false;
				this.refreshing = false;
				this.finished = false;
				this.loading = false;
			} else {
				this.loading = this.searching;
				console.log('有搜索词', this.loading);
				this.page++;
				await this.$service
					.post('home/searchQue', {
						page: this.page,
						pageSize: this.pageSize,
						keywords: this.keywords_confirm,
						major_id: this.majorInfo.major_id
					})
					.then(res => {
						let data = res.data.data;
						this.list = this.list.concat(data);
						this.loading = false;
						this.searching = false;
						if (data.length < this.pageSize) {
							this.finished = true;
						}
						this.refreshing = false;
						this.showList = true;
					});
			}
		},
		onRefresh() {
			console.log('onRefresh');
			this.page = 0;
			this.finished = false;
			this.list = [];
			this.refreshing = true;
			this.onLoad();
		},

		deleteLog() {
			this.$dialog
				.confirm({
					message: '清空关键词搜索记录？',
					confirmButtonText: '确定',
					confirmButtonColor: '#03D3BC',
					cancelButtonText: '取消'
				})
				.then(async () => {
					Toast.loading({
						message: '',
						forbidClick: true,
						loadingType: 'spinner'
					});
					try {
						await this.$service.post('home/delAllSearch', {});
						await this.getLogList();
					} catch {}
					Toast.clear();
				})
				.catch(() => {});
		}
	}
};
</script>

<style scoped lang="less">
@import './search.less';
</style>
